import {Injectable} from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class CookieHelper {
	readonly cookieByPassWelcomeName = 'byPassWelcome';

	// Util to check if a cookie exists
	getCookie(name: string): string | null {
		const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? decodeURIComponent(match[2]) : null;
	}

	// Util to write a cookie
	setCookie(name: string, value: string, days: number) {
		const expires = new Date(Date.now() + days * 864e5).toUTCString();
		document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
	}

	deleteCookie(name: string) {
		document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
	}
}
